import { JobComponent } from "../components/JobComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

export const Work = () => {
    return <div id="work" className="w-11/12 md:w-5/6 xl:w-1/2 m-auto">
        <div className="bg-white">
            <div className="text-left font-bold text-3xl flex items-center mb-8 mt-8">
                <div className="mr-4 bg-primary w-10 h-10 flex justify-center items-center rounded-3xl">
                    <FontAwesomeIcon icon={faBriefcase} color="#FFF" size="xs"/>
                </div>
                <div className="text-primary">
                    WORK EXPERIENCE
                </div>
            </div>
            <JobComponent
                yearFrom="2021"
                yearTo="2026"
                position="Senior Frontend Engineer"
                place="Toggl OÜ (Full-time remote)"
                description={[
                    `Partnered with product managers and designers to define requirements and deliver solutions.`,
                    `Owned end-to-end feature development across frontend and backend systems.`,
                    `Assumed management responsibilities during periods of limited team capacity.`,
                    `Leveraged AI tools for rapid prototyping, testing, and code reviews.`,
                    `Contributed to multiple customer-facing and internal applications.`,
                    `Led a small experimentation team focused on user activation initiatives.`,
                    `Collaborated effectively with distributed teams across multiple time zones.`,
                    `Developed solutions using React, Next.js, Go, Tailwind, TanStack Query`
                ]}
                />
            <JobComponent
                yearFrom="2021"
                yearTo="2021"
                position="Full Stack Developer"
                place="nStudio LLC (Contract)"
                description={[
                    `Developed new features and resolved issues in the NativeScript framework and CLI using TypeScript.`,
                    `Maintained and enhanced templates for React, Angular, and Vue ecosystems.`,
                    `Designed visual assets and promotional materials for community events.`,
                    `Authored and maintained customer-facing technical documentation.`
                ]}
                />
            <JobComponent
                yearFrom="2020"
                yearTo="2021"
                position="Project Manager"
                place="WRD Labs Zrt. (Full-time remote)"
                description={[
                    `Created and maintained project roadmaps, timelines, and delivery plans.`,
                    `Ensured projects remained on schedule and aligned with objectives.`,
                    `Supported, mentored, and motivated cross-functional team members.`,
                    `Managed client communications and aligned stakeholder expectations.`,
                    `Oversaw team workload planning and time allocation.`
                ]}
                />
            <JobComponent
                yearFrom="2019"
                yearTo="2021"
                position="Full Stack Developer"
                place="WRD Labs Zrt. (Full-time)"
                description={[
                    `Transformed product concepts into scalable web and mobile applications.`,
                    `Designed, integrated, and maintained database solutions.`,
                    `Implemented and integrated third-party and internal APIs.`,
                    `Built and maintained testing and staging environments.`,
                    `Automated deployment workflows through CI/CD pipelines.`,
                    `Developed solutions using Next.js, PostgreSQL, WebSockets, Docker, Redux, and AWS.`
                ]}
                />
        </div>
    </div>;
}